import { render, staticRenderFns } from "./ContentPage.vue?vue&type=template&id=97e1ea9a&scoped=true&"
import script from "./ContentPage.vue?vue&type=script&lang=ts&"
export * from "./ContentPage.vue?vue&type=script&lang=ts&"
import style0 from "./ContentPage.vue?vue&type=style&index=0&id=97e1ea9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e1ea9a",
  null
  
)

export default component.exports